<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <LoadingSpinner
            :loading="isLoading"
            :text="this.$lang.sending_data"
          />
          <div slot="header">
            ایجاد
            <strong v-text="$lang.contact"></strong>
          </div>
          <b-form @submit.prevent="save" v-show="!isLoading">
            <b-form-group
              :label="$lang.type"
              label-for="kind_selected"
              :label-cols="$config.form.labelCol"
            >
              <selectFind
                :options="contact_kind_options"
                v-model="$v.kind_selected.$model"
                label="text"
                :isValid="
                  $v.kind_selected.$dirty ? !$v.kind_selected.$error : null
                "
              />

              <b-form-invalid-feedback
                id="kind_selected-feedback"
                :style="{ display: $v.kind_selected.$error ? 'block' : 'none' }"
                >{{
                  $lang.error_required | replace($lang.address_kind)
                }}</b-form-invalid-feedback
              >
            </b-form-group>
            <b-form-group
              :label="$lang.content"
              label-for="content"
              :label-cols="$config.form.labelCol"
            >
              <b-form-input
                id="content"
                type="text"
                v-model="$v.content.$model"
                :state="$v.content.$dirty ? !$v.content.$error : null"
                :autocomplete="$lang.address"
                :rows="this.$config.form.textareaRows"
              ></b-form-input>
              <b-form-invalid-feedback id="father_name-feedback">{{
                $lang.error_required | replace($lang.address)
              }}</b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              :label="$lang.description"
              label-for="address"
              :label-cols="$config.form.labelCol"
            >
              <b-form-textarea
                id="description"
                type="text"
                v-model="$v.description.$model"
                :autocomplete="$lang.description"
                :rows="this.$config.form.textareaRows"
              ></b-form-textarea>
            </b-form-group>
            <div slot="footer" class="form-group form-btn">
              <b-button
                type="reset"
                class="mr-2"
                variant="outline-danger"
                @click="handleBack"
              >
                <mdicon name="close" size="20" />
                {{ $lang.cancelButton }}
              </b-button>
              <b-button
                v-if="isAdmin(parentPermissions)"
                type="submit"
                variant="success"
              >
                <mdicon name="check" size="20" />
                {{ $lang.submitButton }}
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { required } from "vuelidate/lib/validators";
import { renderEumOptions, isAdmin } from "@/shared/utils";

export default {
  name: "add-contact",
  components: {
    LoadingSpinner,
  },
  validations: {
    kind_selected: {
      required,
    },
    content: {
      required,
    },
    description: {},
  },
  props: {
    entity: {
      type: String,
      default: "person",
    },
    entityId: { type: String },
    isModal: {
      type: Boolean,
      default: false,
    },
    backUrl: {
      type: String,
      default: "",
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
      kind_selected: null,
      description: "",
      content: "",
    };
  },
  computed: {
    contact_kind_options() {
      return renderEumOptions("contact_kind");
    },
  },
  methods: {
    isAdmin,
    handleBack() {
      if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    clear() {
      this.name = "";
      this.description = "";
      this.category_id = null;
      this.exercise_id = null;
    },
    afterSave() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }

      try {
        this.isLoading = true;

        let api_url = "";
        if (this.entity === "person") {
          api_url = this.$config.resources.person_contact;
        }
        if (this.entity === "company") {
          api_url = this.$config.resources.company_contact;
        }
        const url =
          this.$config.api_url + api_url.replace("{0}", this.entityId);
        let payload = {
          kind_id: this.kind_selected.value,
          content: this.content,
          description: this.description,
        };
        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);
        this.afterSave();
        this.$emit("getItems");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

